import { isEmpty } from 'lodash';
import moment from 'moment';

export function getLiveProgramProgress(startTime: string, endTime: string) {
  if (isEmpty(startTime) || isEmpty(endTime)) {
    return undefined;
  }

  const now = moment().unix();
  const start = moment(startTime).unix();
  const end = moment(endTime).unix();
  const percent = (now - start) / (end - start);

  return Math.ceil(Number(percent <= 1 ? percent : 0) * 100);
}
